import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";

const usePerformanceDashboardHeader = (allHotelIds) => {
  const [propertyFilterMenuAnchor, setPropertyFilterMenuAnchor] =
    useState(null);
  const [period, setPeriod] = useState("Today");
  const [allPropertyFilter, setAllPropertyFilter] = useState(true);
  const [propertyFilterItemsTemp, setPropertyFilterItemsTemp] =
    useState(allHotelIds);
  const [doComparison, setDoComparison] = useState(false);

  const propertyFilterLabel = useMemo(() => {
    return allPropertyFilter
      ? "All properties (" + propertyFilterItemsTemp.length + ")"
      : "Property (" + propertyFilterItemsTemp.length + ")";
  }, [allPropertyFilter, propertyFilterItemsTemp]);

  const handlePropertyFilterMenuOpen = (event) => {
    setPropertyFilterMenuAnchor(event.currentTarget);
  };
  const handlePropertyFilterMenuClose = () => {
    setPropertyFilterMenuAnchor(null);
  };

  const handlePeriodChange = (p) => {
    setPeriod(p);
  };

  const handlePropertyFilterItemsTemp = (val) => {
    setPropertyFilterItemsTemp(val);
  };

  const toggleAllPropertyFilter = () => {
    setAllPropertyFilter((apf) => !apf);
  };
  const handleSelectPropertyInFilter = (name) => {
    if (propertyFilterItemsTemp.includes(name)) {
      setPropertyFilterItemsTemp((pf) =>
        pf.filter((property) => property !== name)
      );
    } else {
      setPropertyFilterItemsTemp((pf) => [...pf, name]);
    }
  };

  const toggleDoComparison = () => {
    setDoComparison((c) => !c);
  };

  useEffect(() => {
    if (propertyFilterItemsTemp.length === allHotelIds.length) {
      setAllPropertyFilter(true);
    }
  }, [propertyFilterItemsTemp, allHotelIds]);

  useEffect(() => {
    if (allPropertyFilter) {
      setPropertyFilterItemsTemp(allHotelIds);
    } else {
      setPropertyFilterItemsTemp([]);
    }
  }, [allPropertyFilter, allHotelIds]);

  return {
    propertyFilterMenuAnchor,
    period,
    propertyFilterLabel,
    allPropertyFilter,
    propertyFilterItemsTemp,
    doComparison,
    handlePropertyFilterMenuClose,
    handlePropertyFilterMenuOpen,
    handlePeriodChange,
    toggleAllPropertyFilter,
    handleSelectPropertyInFilter,
    handlePropertyFilterItemsTemp,
    toggleDoComparison,
  };
};

export default usePerformanceDashboardHeader;
